import { render, staticRenderFns } from "./AdmissionCancel.vue?vue&type=template&id=4928a64d&scoped=true"
import script from "./AdmissionCancel.vue?vue&type=script&lang=js"
export * from "./AdmissionCancel.vue?vue&type=script&lang=js"
import style0 from "./AdmissionCancel.vue?vue&type=style&index=0&id=4928a64d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4928a64d",
  null
  
)

export default component.exports